import {
  CLEAR_QUEUE,
  ADD_TO_QUEUE,
  REMOVE_FROM_QUEUE,
  SET_QUEUE_POSITION
} from "@/store/mutation-types";

export default {
  clear({ commit }) {
    commit(CLEAR_QUEUE);
  },
  add({ commit }, tracks = []) {
    commit(ADD_TO_QUEUE, tracks);
  },
  remove({ commit }, trackID) {
    commit(REMOVE_FROM_QUEUE, trackID);
  },
  setPosition({ state, commit }) {
    const index = state.currentIndex + 1;
    const max = state.tracklist.length;
    const position = (() => {
      if (index >= max && index === 1) {
        return "one";
      } else if (index === 1) {
        return "first";
      } else if (index >= max) {
        return "last";
      } else {
        return "middle";
      }
    })();

    commit(SET_QUEUE_POSITION, position);
  }
};
